import history from '../../containers/History'
import { handleOnNavClick as handleOnSingleReportNavClick } from '../../containers/ReportFile/module'
import { ROUTES, DATASOURCES, CLEAR_STATE } from '../../constants'
import { getDataSource, getMe, getPatient, getInterpretations, getPatientReports } from '../../store/appReducer'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'PatientReport.'
export const UPDATE_SELECTED_REPORT_ID = `${PREFIX}UPDATE_SELECTED_REPORT_ID`
export const UPDATE_SELECTED_PATIENT_ID = `${PREFIX}UPDATE_SELECTED_PATIENT_ID`

// ------------------------------------
// Actions
// ------------------------------------
export const updateSelectedReportId = id => ({
  type: UPDATE_SELECTED_REPORT_ID,
  payload: id,
})
export const updateSelectedPatientId = id => ({
  type: UPDATE_SELECTED_PATIENT_ID,
  payload: id,
})

export const setInitialPatientReportData = match => (dispatch, getState) => {
  const {
    patientId,
    reportId,
  } = match.params

  dispatch(updateSelectedReportId(reportId))
  dispatch(updateSelectedPatientId(patientId))
}

export const getPatientReportData = (forceUpdate = false) => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
  const interpretationsDataSource = getDataSource(getState(), DATASOURCES.INTERPRETATIONS)
  const patientsDataSource = getDataSource(getState(), DATASOURCES.PATIENTS)
  const {
    selectedPatientId,
  } = getState().patientReport

  let promises

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  if (interpretationsDataSource.data && !forceUpdate) {
    // no-op
  } else {
    promises = promises
      .then(() => {
        const me = getDataSource(getState(), DATASOURCES.ME)
        const {
          teams,
        } = me.data

        return dispatch(getInterpretations(teams[0].id))
      })
  }

  if (!patientsDataSource.data || (patientsDataSource.data && !patientsDataSource.data.byId[selectedPatientId]) || forceUpdate) {
    promises = promises
      .then(() => dispatch(getPatient(selectedPatientId)))
  }

  return promises
    .then(() => dispatch(getPatientReports(selectedPatientId)))
}

export const handleOnNavClick = (patientId, reportId) => (dispatch, getState) => {
  history.push(`${ROUTES.PATIENTS_PATIENT_FILE}/${patientId}/reports/${reportId}`)
  dispatch(handleOnSingleReportNavClick())
}

const initialState = {
  selectedPatientId: null,
  selectedReportId: null,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_SELECTED_REPORT_ID]: (state, action) => ({
    ...state, selectedReportId: action.payload,
  }),
  [UPDATE_SELECTED_PATIENT_ID]: (state, action) => ({
    ...state, selectedPatientId: action.payload,
  }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function patientReportReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientReport/module.js